import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import metaConfig from "../meta/metaConfig";

const MetaHelmet = () => {
  const location = useLocation();
  const meta = metaConfig[location.pathname] ?? {
    title: "Jivi Solutions",
    description: "Smart workforce management software.",
  };

  return (
    <Helmet key={location.pathname}>
      <title>{meta.title}</title>
      <meta
        key="description"
        name="description"
        content={meta.description}
      />
    </Helmet>
  );
};

export default MetaHelmet;
